import axios from 'axios';

const API_BASE = process.env.REACT_APP_BASEURL + 'backoffice/railway';

export const fetchRailwayDetails = ({
  pageNumber,
  pageSize,
  firstName,
  mobileNumber,
  isUserVerified
}) => {
  // build params object dynamically
  const params = { pageNumber, pageSize };
  if (firstName)      params.firstName      = firstName;
  if (mobileNumber)          params.mobileNumber          = mobileNumber;
  if (isUserVerified !== null && isUserVerified !== undefined) {
    params.isUserVerified = isUserVerified;
  }

  return axios.get(`${API_BASE}/list/filter`, { params });
};

export const updateRailwayDetails = (record) =>
  axios.put(`${API_BASE}/updateDetails`, record);
